import { useMutation, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import {
  fetchFormConfigurationsById,
  fetchFormConfigurationThemeById,
  updateFormConfigurationById,
  updateFormConfigurationThemeById,
} from "@/lib/api/resources/formConfigurations";
import { Spin } from "antd";
import { Builder } from "./components/Builder";
import { useMemo } from "react";

export const FormConfigurationBuilder = () => {
  const { id } = useParams();

  const formConfigurationQuery = useQuery({
    queryKey: ["form-configuration", id],
    queryFn: () => fetchFormConfigurationsById(id!),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  const themeId = useMemo(
    () => formConfigurationQuery.data?.configuration.themeId,
    [formConfigurationQuery.data],
  );

  const formConfigurationThemeQuery = useQuery({
    queryKey: ["form-configuration-theme", themeId],
    queryFn: () => fetchFormConfigurationThemeById(themeId!),
    enabled: !!themeId,
    refetchOnWindowFocus: false,
  });

  const updateFormConfigurationMutation = useMutation({
    mutationFn: async (data: any) =>
      updateFormConfigurationById(id!, {
        name: formConfigurationQuery.data?.name,
        type: formConfigurationQuery.data?.type,
        configuration: JSON.stringify(data),
      }),
  });

  const updateFormConfigurationThemeMutation = useMutation({
    mutationFn: async (data: any) =>
      updateFormConfigurationThemeById(themeId!, {
        name: formConfigurationThemeQuery.data?.name,
        configuration: JSON.stringify(data),
      }),
  });

  if (
    formConfigurationQuery.isFetching ||
    formConfigurationThemeQuery.isFetching
  ) {
    return <Spin />;
  }

  return (
    <div style={{ height: "100%", overflowY: "hidden" }}>
      {formConfigurationQuery.data && formConfigurationThemeQuery.data ? (
        <Builder
          formConfiguration={formConfigurationQuery?.data?.configuration}
          themeConfiguration={formConfigurationThemeQuery?.data?.configuration}
          updateFormConfigurationMutation={updateFormConfigurationMutation}
          updateFormConfigurationThemeMutation={
            updateFormConfigurationThemeMutation
          }
        />
      ) : null}
    </div>
  );
};
